import styled from "@emotion/styled";
import { theme } from "@/config/theme";
import { DESKTOP_HEADER_MEDIA_QUERY } from "./HeaderConstants";
import SvgIcon from "@digital-hig/mui/SvgIcon";
import Typography from "@digital-hig/mui/Typography";

interface HeaderWrapperProps {
  sticky?: boolean;
}

export const HeaderWrapper = styled.header<HeaderWrapperProps>`
  position: ${(props) => (props.sticky ? "sticky" : "relative")};
  top: 0;
  z-index: 100;
`;

// export const HeaderWrapper = styled.header(({ sticky = false }: { sticky?: boolean }) => ({
//   position: sticky ? "sticky" : "relative",
//   top: 0,
//   zIndex: 100
// }));

export const HeaderTop = styled.div({
  background: theme.primitives.colors.primary.black,
  paddingTop: theme.primitives.spacings[2],
  paddingBottom: theme.primitives.spacings[1],
  borderBottom: "1px solid rgb(48, 48, 48)",
  //   boxShadow: theme.tokens.effects["divider-0-bottom-on-fill-primary"].boxShadow,
  display: "flex",
  alignItems: "left"
});

export const HeaderMenuTop = styled.div({
  background: theme.primitives.colors.primary.black,
  borderBottom: "1px solid rgb(48, 48, 48)",
  //   boxShadow: theme.tokens.effects["divider-0-bottom-on-fill-primary"].boxShadow,
  display: "flex",
  alignItems: "center"
});

export const HeaderTopBelow = styled.div({
  background: theme.primitives.colors.primary.black,
  paddingTop: theme.primitives.spacings[2],
  paddingBottom: theme.primitives.spacings[2],
  //   boxShadow: theme.tokens.effects["divider-0-bottom-on-fill-primary"].boxShadow,
  display: "flex",
  alignItems: "center"
});

export const HeaderWidthContainer = styled.div({
  marginLeft: "auto",
  marginRight: "auto",
  width: "100%",
  paddingLeft: theme.primitives.spacings[4],
  paddingRight: theme.primitives.spacings[4],
  color: theme.primitives.colors.primary.white,
  [DESKTOP_HEADER_MEDIA_QUERY]: {
    maxWidth: `calc(${theme.primitives.grid["max-width"]} + (${theme.primitives.spacings[9]} * 2))`,
    paddingLeft: theme.primitives.spacings[9],
    paddingRight: theme.primitives.spacings[9]
  }
});

export const HeaderTopInner = styled.div({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between"
});

export const HeaderTopSection = styled.div({
  display: "flex",
  alignItems: "center"
});

export const LogoLink = styled.div({
  "&:focus-visible": {
    outline: `1.5px solid ${theme.primitives.colors.accent.iris}`,
    outlineOffset: 1.5
  }
});

export const AuthMenuWrapper = styled.div({
  minWidth: 100,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end"
});

export const IconLink = styled.a({
  background: "none",
  appearance: "none",
  border: "none",
  display: "flex",
  textDecoration: "none",
  alignItems: "center",
  padding: `${theme.primitives.spacings[2]} ${theme.primitives.spacings[2]}`,
  marginLeft: theme.primitives.spacings[1],
  marginRight: theme.primitives.spacings[1],
  borderRadius: theme.primitives.borderRadii.medium,
  "&:hover": {
    background: theme.primitives.colors.tint["slate-650"]
  },
  "&:focus-visible": {
    outline: `1px solid ${theme.primitives.colors.accent.iris}`,
    outlineOffset: "-1px"
  },
  "&:last-of-type": {
    marginRight: 0
  }
});

export const IconButton = styled(IconLink)();

IconButton.defaultProps = {
  as: "button"
};

export const SvgIconWhite = styled(SvgIcon)({
  color: theme.primitives.colors.primary.white,
  transform: "scale(1.1)"
});

export const TopHeaderText = styled(Typography)({
  marginLeft: theme.primitives.spacings[1],
  fontWeight: 600
});

TopHeaderText.defaultProps = {
  variant: "body-copy-small",
  color: "ink-on-fill-primary",
  as: "span"
};
